export const safeReorderArray = <T>(
	array: T[],
	from: number,
	to: number,
): T[] => {
	const newArray = [...array];
	if (to >= array.length) {
		let k = to - array.length + 1;
		while (k--) array.push(undefined as T);
	}
	const item = newArray.splice(from, 1)[0];
	newArray.splice(to, 0, item);
	return newArray;
};
